export const SrilankaImages = {
  d1: require('./port2.jpg').default,
  d2: require('./srilankabg.jpg').default,
  db1: require('./beach1.jpg').default,
  db2: require('./beach2.jpg').default,
  dc1: require('./cult1.jpg').default,
  dc2: require('./cult2.jpg').default,
  dh1: require('./hotel1.jpg').default,
  dh2: require('./hotel2.jpg').default,
  dp1: require('./pack1.jpg').default,
  dp2: require('./pack2.jpg').default,
  dp3: require('./pack3.jpg').default,
  dp4: require('./pack4.jpg').default,
  do1: require('./food1.jpg').default,
  do2: require('./food2.jpg').default,
  d3: require('./port1.jpg').default,
}
